import { FileIcon, IdeaIcon } from '@/assets/icons'
import { GetIdeaResponse } from '@orbit/api-types'
import React from 'react'
import { ideaThumbnailUrl } from '../ideaFilters'
import {
	AttachmentBadge,
	IdeaName,
	IdeasGrid,
	IdeaThumbnail,
	IdeaTile,
	ThumbnailFrame,
} from './IdeaGrid.styles'
import { iconSizes } from '@/theme/tokens'
import { TestIds } from '@/testIds'

interface IdeaTileGridProps {
	ideas: GetIdeaResponse[]
	onSelect: (idea: GetIdeaResponse) => void
	/**
	 * Show the attachment count badge on tiles that have files. Members only —
	 * public visitors can't resolve trip files (ADR 0003).
	 */
	showAttachments?: boolean
}

/**
 * The flat grid of square idea tiles — link-preview thumbnail with the name
 * below — shared by the member ideas page and the public one, so the two can't
 * drift. Ideas without a link preview fall back to a centered icon. What a tile
 * click opens is the caller's business (edit form vs read-only popup).
 */
const IdeaTileGrid: React.FC<IdeaTileGridProps> = ({ ideas, onSelect, showAttachments }) => (
	<IdeasGrid>
		{ideas.map(idea => {
			const thumbnail = ideaThumbnailUrl(idea)
			const attachmentCount = idea.fileIds?.length ?? 0
			return (
				<IdeaTile key={idea.id} type="button" onClick={() => onSelect(idea)} data-testid={TestIds.idea.cell(idea.name)}>
					<ThumbnailFrame>
						<IdeaThumbnail>
							{thumbnail ? (
								<img src={thumbnail} alt={idea.name} loading="lazy" />
							) : (
								<IdeaIcon sx={{ fontSize: iconSizes.hero }} />
							)}
						</IdeaThumbnail>
						{showAttachments && attachmentCount > 0 && (
							<AttachmentBadge title={`${attachmentCount} attachment${attachmentCount > 1 ? 's' : ''}`}>
								<FileIcon sx={{ fontSize: iconSizes.xs }} />
								{attachmentCount}
							</AttachmentBadge>
						)}
					</ThumbnailFrame>
					<IdeaName title={idea.name}>{idea.name}</IdeaName>
				</IdeaTile>
			)
		})}
	</IdeasGrid>
)

export default IdeaTileGrid
